<div class="top-section">
    <h3>
        Tracking Voyage
    </h3>
</div>

<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <div class="rate-request-form-inner">
                    <div class="pRel">
                        <p-dropdown [options]="trackigStatus" optionLabel="viewValue" [(ngModel)]="selectedStatusn"
                            (onChange)="onChangeStatus()" placeholder="Select Status" [filter]="false"
                            class="p-dropdown">
                        </p-dropdown>
                    </div>

                    <div class="request-btn">
                        <input type="text" class="form-control" pInputText size="50" placeholder="Enter tracking number"
                            (change)="filterSearch($event.target.value)">
                        <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                                    src="../../../assets/images/Group 103.svg"></button></div>
                    </div>
                </div>
                <!-- <div class="rate-request-form-innera text-right mb-3">
                    <a class="btn btn-signIn"  href="javascript:void(0)" (click)="getPortdetails(0,'add')"
                        data-toggle="modal" data-target=".view-offredrate" >
                        <i class="fa fa-plus"></i> Add Port</a>
                </div> -->
                <div class="table-responsive rate-request-tbl">

                    <p-table [value]="trackingData">

                        <ng-template pTemplate="header"
                            3333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333333qQA>
                            <tr>
                                <th>Tracking number</th>
                                <th>Shipping line</th>
                                <th>Vessels</th>
                                <th>From Port</th>
                                <th>To Port</th>
                                <th>Planned Arrival</th>
                                <th>New Arrival date</th>
                                <th>Difference in days</th>
                                <th>Status</th>
                                <th>Details</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-track>
                            <tr style="cursor: pointer;"
                                (click)="getTrackingDetails(track.trackingNumber,track.shippingLineId,track.vesselsId,track.fromPortId,track.toPortId)">
                                <td>{{ track.trackingNumber }}</td>
                                <td><img class="image1" src="{{track.companyLogo}}"></td>
                                <td>{{ track.vesselsName }}</td>

                                <td>{{ track.fromPortName }}</td>
                                <td>{{ track.toPortName }}</td>
                                <td>{{ track.toPlanArrivalDate | date: 'dd-MM-yyyy' }} </td>
                                <td>{{ track.toActualArrivalDate | date: 'dd-MM-yyyy'}}</td>
                                <!--
                                    Number of days
                                -->
                                <td *ngIf="track.noOfDay == 0">{{ track.noOfDay }}</td>
                                <td *ngIf="track.noOfDay > 0" class="text-danger">{{ track.noOfDay }}</td>
                                <td *ngIf="0 > track.noOfDay" class="text-success">{{ track.noOfDay }}</td>
                                <!--
                                    Tracking status
                                -->


                                <td *ngIf="track.trackingStatus == 'Delayed'" class="text-danger">{{
                                    track.trackingStatus }}</td>
                                <td *ngIf="track.trackingStatus == 'On time'">{{
                                    track.trackingStatus }}</td>
                                <td *ngIf="track.trackingStatus != 'On time' && track.trackingStatus != 'Delayed'"
                                    class="text-success">{{
                                    track.trackingStatus }}</td>

                                <!--
                                    See details
                                -->
                                <td>
                                    <!-- <a class="action-btn " tooltipPosition="top" pTooltip="Add Tracking"
                                        data-toggle="modal" data-target=".add-modal">
                                        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                            width="18px" height="18px" fill="#505d6b">
                                            <path
                                                d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7 4 L 7 7 L 4 7 L 4 8 L 7 8 L 7 11 L 8 11 L 8 8 L 11 8 L 11 7 L 8 7 L 8 4 Z" />
                                        </svg>
                                    </a> -->
                                    <a class="action-btn text-success" tooltipPosition="top" pTooltip="View Tracking"
                                        data-toggle="modal" data-target=".view-addaliases"
                                        (click)="getTrackingDetails(track.trackingNumber,track.shippingLineId,track.vesselsId,track.fromPortId,track.toPortId)">
                                        <i class="fa fa-eye"></i>
                                    </a>


                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <p-paginator *ngIf="totalCount > 0" [rows]="pageSize" [rowsPerPageOptions]="[5,10,20]"
                    [totalRecords]="totalCount" (onPageChange)="paginate($event)"></p-paginator>
                <div *ngIf="totalCount == 0">
                    <span>No records found</span>
                </div>
            </div>
        </div>
    </div>
</section>